export { core } from '@/features/dashboard/localization/core';
export { errors } from '@/features/dashboard/localization/errors';
export { messages } from '@/features/dashboard/localization/messages';
